module.exports = __webpack_public_path__ + "static/ykawamot-ca46d072ed40dc66b4a3460cd5983606.jpg";